<template>
  <div>
    <el-button v-if="shenType==0" type="success" class="examine-btn" @click="pass">通过</el-button>
    <el-button v-if="shenType==1" type="success" class="examine-btn" @click="passDialog=true">通过</el-button>
    <el-button type="danger" class="examine-btn" @click="closeDialog = true">拒绝</el-button>

    <el-dialog
        title="设置信息"
        :visible.sync="passDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <el-form :model="passForm" :rules="rules" ref="passForm" label-width="120px">
        <el-form-item label="隶属协调中心 " prop="xtzx_id">
          <el-select v-model="passForm.xtzx_id" filterable placeholder="请选择隶属协调中心"
                     style="width: 100%;">
            <el-option
                v-for="item in parentTypes"
                :key="item.type"
                :label="item.name"
                :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到期时间类型" prop="resource">
          <el-radio-group v-model="passForm.resource">
            <el-radio label="1">默认到期时间</el-radio>
            <el-radio label="2">自定义到期时间</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="到期时间 " prop="due_date" v-if="Number(passForm.resource) === 2">
          <!--          <el-select v-model="passForm.due_date" filterable placeholder="请选择到期时间" style="width: 100%;">-->
          <!--            <el-option-->
          <!--                v-for="item in dueDate"-->
          <!--                :key="item.type"-->
          <!--                :label="item.name"-->
          <!--                :value="item.type">-->
          <!--            </el-option>-->
          <!--          </el-select>-->

          <el-date-picker
              style="width: 100%;"
              v-model="passForm.due_date"
              align="right"
              type="date"
              placeholder="请选择到期时间"
              :picker-options="pickerOptions1">
          </el-date-picker>


        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="closeAllDialog">关闭</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitForm('passForm')">通过</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="拒绝原因"
        :visible.sync="closeDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <el-input type="textarea" placeholder="请输入驳回原因" v-model="remark"></el-input>
      <div v-if="orgType === 6">
        分配下属
      </div>
      <div class="flex align-center justify-around margin-top">
        <el-button class="padding-lr-xl" @click="closeAllDialog">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="remarkForm">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {dueDate} from "@/tools/utils";
import {orgDoShen, orgGetXietiao} from "@/api/projectOffice";

export default {
  name: "examine",
  props: {
    id: {
      type: Number
    },
    region: {
      type: String
    },
    orgType: {
      type: Number
    },
    level: {
      type: Number
    },
    xtzx_id: {
      type: Number
    }
  },
  data() {
    return {
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      shenType: '',
      dueDate: dueDate(),
      parentTypes: [],
      passForm: {
        xtzx_id: '',
        resource:'1',
        due_date: ''
      },
      rules: {
        xtzx_id: [{required: true, message: "请选择隶属协调中心", trigger: "change"}],
        resource: [{required: true, message: "请选择到期时间类型", trigger: "change"}],
        due_date: [{required: true, message: "请选择到期时间", trigger: "change"}],
      },
      remark: '',
      passDialog: false,
      closeDialog: false,
    }
  },
  created() {
    this.shenType = Number(this.$route.query.shenType)
    this.passForm.xtzx_id = this.xtzx_id?Number(this.xtzx_id):''
    this.getLsxtList()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitPass()
        }
      });
    },
    async submitPass() {
      let _date = Number(this.passForm.resource) === 1 ? '' : this.$tools.ZHDate(new Date(this.passForm.due_date))
      let _state = await orgDoShen(2, this.$route.query.shenId, this.passForm.xtzx_id, _date, '')
      this.$message.success(_state.msg)
      this.$router.go(-1)
    },
    async pass() {
      let _state = await orgDoShen(1, this.$route.query.shenId, '', '', '')
      this.$message.success(_state.msg)
      this.$router.go(-1)
    },
    async remarkForm() {
      if (!this.remark) return this.$message.error('请输入驳回原因')
      let _state = await orgDoShen(this.shenType === 0 ? -1 : -2, this.$route.query.shenId, '', '', this.remark)
      this.$message.success(_state.msg)
      this.$router.go(-1)
    },
    closeAllDialog() {
      this.passDialog = false
      this.closeDialog = false
    },
    //  获取隶属协调中心
    async getLsxtList() {
      let _data = await orgGetXietiao(
          this.level,
          this.region,
          this.orgType)
      let arr = []
      _data.data.map(item => {
        arr.push({
          type: item.org_id,
          name: item.org_name
        })
      })
      this.parentTypes = arr
    },
  },
  watch:{

  }
}
</script>

<style scoped lang="scss">

</style>